import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { track } from "@/utils/ga";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ShutupList() {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    setError("");
    try {
      const res = await fetch(`${API}/api/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, phone }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "failed");
      setState(data.status === "already" ? "already" : "ok");
      if (data.status === "ok") track("generate_lead", { method: "shutup_list" });
    } catch (err) {
      setState("error");
      setError(err.message === "failed" ? "something broke — try again?" : err.message);
    }
  };

  return (
    <section data-testid="shutup-list-section" className="bg-black text-paper py-24 sm:py-32 border-t border-white/10">
      <div className="mx-auto max-w-2xl px-5 sm:px-10 text-center">
        <Reveal>
          <p className="font-sans text-turq text-xs font-semibold tracking-[0.35em] mb-6">THE SHUTUP LIST</p>
          <h2 className="font-display leading-[0.9] text-[clamp(2.6rem,9vw,6rem)]" data-testid="list-title">
            GET TOLD <span className="text-pink">FIRST.</span>
          </h2>
          <p className="font-sans text-paper/60 text-sm sm:text-base mt-6">
            200 pieces. They go fast. Leave your email — first dibs on drop #2, secret restocks, nothing else. No spam, just noise.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          {state === "ok" || state === "already" ? (
            <div className="mt-10" data-testid="list-success">
              <p className="font-display text-4xl sm:text-5xl text-acid">
                {state === "ok" ? "YOU'RE IN." : "ALREADY IN, LOUDMOUTH."}
              </p>
              <p className="font-hand text-2xl text-paper/60 mt-4 -rotate-1">
                {state === "ok" ? "check your inbox — we just wrote to you." : "you're already on the list."}
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-10" data-testid="list-form">
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="YOUR EMAIL"
                data-testid="list-email-input"
                className="w-full bg-transparent border-2 border-paper/30 focus:border-acid outline-none font-sans font-bold tracking-[0.15em] text-paper px-5 py-4 placeholder:text-paper/30 text-center"
              />
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value.replace(/[^\d+]/g, "").slice(0, 15))}
                placeholder="WHATSAPP NUMBER (OPTIONAL)"
                data-testid="list-phone-input"
                className="w-full mt-3 bg-transparent border-2 border-paper/30 focus:border-acid outline-none font-sans font-bold tracking-[0.15em] text-paper px-5 py-4 placeholder:text-paper/30 text-center"
              />
              {state === "error" && (
                <p className="font-sans text-blood text-xs font-bold tracking-[0.2em] mt-3" data-testid="list-error">
                  {error.toUpperCase()}
                </p>
              )}
              <button
                data-testid="list-submit-button"
                type="submit"
                disabled={state === "sending"}
                className="mt-5 w-full font-sans bg-pink text-black font-bold tracking-[0.15em] px-6 py-4 hover:bg-acid transition-colors disabled:opacity-60"
              >
                {state === "sending" ? "JOINING…" : "COUNT ME IN →"}
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  );
}
